import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const ResetPassword = MatxLoadable({
    loader: () =>
        import ("./ResetPassword")
})
const AllResetPassword = MatxLoadable({
    loader: () =>
        import ("./AllResetPassword")
})




const settings = {
    activeLayout: "layout1",
    layout1Settings: {
        topbar: {
            show: false
        },
        leftSidebar: {
            show: false,
            mode: "close"
        }
    },
    layout2Settings: {
        mode: "full",
        topbar: {
            show: false
        },
        navbar: { show: false }
    },
    secondarySidebar: { show: false },
    footer: { show: false }
};

const ResetPasswordRoutes = [
    {
        path: "/reset_password",
        component: AllResetPassword,
        settings
    },

];

export default ResetPasswordRoutes;